import { useDispatch } from 'react-redux';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { matchPath, useLocation } from 'react-router';
import Sidebar from './index';
import useSidebarMenu from '../../hooks/SidebarMenuHook';
import { rootPath } from '../../constants/routes';
import logoMab from '../../assets/logo/logo_mab.svg';
import { IBorrowerProfileDataAction } from '../../actions/borrowerProfileAction';
import { BorrowerActionTypes } from '../../constants/actionTypes';

const SidebarController: React.FC = ({ children }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const menu = useSidebarMenu().items;
  const [fullWidth, setFullWidth] = useState(false);
  const location = useLocation();

  function getWidthStyle() {
    if (fullWidth) {
      return 'w-full';
    }
    return 'min-w-content-area-width md:w-[672px] lg:w-4/6';
  }

  function resetBorrowerProfile() {
    const action: IBorrowerProfileDataAction = {
      type: BorrowerActionTypes.FETCH_BORROWER_PROFILE_DATA,
      borrowerProfileData: undefined,
    };
    dispatch(action);
  }

  return (
    <div className="flex w-full h-full bg-gray-50">
      <Sidebar
        menu={menu}
        icon={logoMab}
        clickHandler={(item) => {
          history.push(item.route);
        }}
        onClickLogout={() => {
          resetBorrowerProfile();
          history.replace(rootPath);
        }}
        onSelectedMenuItemIndex={() => {
          const currentIndex = menu.findIndex((i) => {
            const isRoute = matchPath(location.pathname, { path: i.route })?.isExact;
            return isRoute;
          });
          setFullWidth(menu[currentIndex].fullPageWidth);
        }}
      />
      <div className={`ml-[227px] flex flex-col h-full overflow-y-auto bg-white border-gray-200 border-r min-h-screen ${getWidthStyle()}`}>
        {children}
      </div>
    </div>
  );
};

export default SidebarController;
